import { Component, ElementRef, OnInit,ViewChild,OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { LeftSideComponent } from './leftSide/leftSide.component';
import { RightSideComponent } from './rightSide/rightside.component';
import { LobbyComponent } from '../lobby/lobby.component';
import { environment } from './../../environments/environment';
import { MainService } from '../_services/main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserService } from '../_services';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'users-account',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})

export class UsersComponent implements OnInit,OnDestroy {
  sub_isMobileScreen: Subscription;
SITE_URL = `${environment.SITE_URL}`;
assetURL = `${environment.assetURL}`;
currency_symbol = `${environment.CURRENCY_SYMBOL}`;
user_id = 0;
bonus_amount = 0;
currentUser : any;
userSettings : any;
userData : any;
miniLobby : any;
referrals =[];
tooltipText='Copy';
referral_code_validation='';
referral_send_validation='';
sucessMessage='';
editMode=false;
isMac=false;
submitted = false;
disableSave = true;
showLoader='';
sendReferralForm: FormGroup;
sub_userData: Subscription;
isLoading = true;
isMobile = false;
specialReferCode = '';
@ViewChild(LeftSideComponent,{}) feedChild: LeftSideComponent;
@ViewChild(RightSideComponent,{}) rightChild: RightSideComponent;
@ViewChild('referral_link') referral_link: ElementRef;
@ViewChild('referral_code') referral_code: ElementRef;
@ViewChild('copyIcon') copyIcon: ElementRef;
  newcomponent = "Entered in new component created";
  constructor(private store: Store<any>,public dialog: MatDialog, private router: Router,private _appService:MainService,private spinner: NgxSpinnerService,private userService:UserService,private formBuilder: FormBuilder) {
    if (navigator.appVersion.indexOf("Mac")!=-1) this.isMac =true;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
    }
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
  }
  
  ngOnInit() {
    this.checkSpecialReferCode();
    this.sendReferralForm = this.formBuilder.group({
      email: ['', [Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
  });

    this.spinner.show();
    this.isLoading = true;
    this._appService.getSetting()
    .subscribe(shows => {
      if (shows.status === 'success') {
        this.userSettings = shows.entities;
        this.isLoading = false;
      }
    }, err => {
      console.log(err);
    });
    this.userService.getAllRefferals(this.user_id)
    .subscribe(shows => {
      if (shows.status === 'success') {
        this.referrals =shows.entities;
        this.bonus_amount =shows.bonus_amount;
      }
    }, err => {
      console.log(err);
    });
    this.sub_userData = this.store.select('authData').subscribe(state => {
      if (state.length > 0) {
      this.userData = state[0];
      }
    });
    this.spinner.hide();
}

ngOnDestroy() {
  if (this.sub_isMobileScreen) { this.sub_isMobileScreen.unsubscribe(); }
}
copyToClipboard(){
  let val =  this.referral_link.nativeElement.innerHTML;
  this.copyIcon.nativeElement.setAttribute("matTooltip","Copied");
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  setTimeout(()=>{
  this.tooltipText = 'Copy';
  },3000)
  this.tooltipText = 'Copied';
}
  getTooltipContent(){
     return this.tooltipText;
  }
  editModeCall(editMode){
    this.editMode = editMode;
    setTimeout(()=>{
      this.keydownReferralCode();
    },100)
  }
  submitRefferals(){
    this.showLoader='Save';
    this.disableSave=true;
    let referalCode = this.referral_code.nativeElement.value;
    this.userService.saveRefferals(referalCode,this.user_id)
    .subscribe(res => {
      this.disableSave=false;
      this.showLoader='';
      if (res.status === 'success') {
        this.editMode = false;
        this.userData.referral_code = referalCode;
      } else{
        this.referral_code_validation = res.message;
        setTimeout(()=>{
          this.referral_code_validation = '';
          },5000)
      }
    }, err => {
      console.log(err);
    });
  }
 
  keydownReferralCode(){
      this.referral_code_validation='';
      let referalCode = this.referral_code.nativeElement.value;
      if(referalCode==this.userData.referral_code){
        this.disableSave = true;
      } else{
        this.disableSave = false;
      }
      
  }
  
  get f() { return this.sendReferralForm.controls; }

  sendReferral(){
    this.submitted = true;
    if (this.sendReferralForm.invalid) {
        return;
    }
    let email_refer = this.sendReferralForm.value.email;
    this.sendReferralForm.controls['email'].setValue(this.sendReferralForm.value.email);
    this.showLoader='Send';
    this.userService.sendRefferals(email_refer)
    .subscribe(res => {
      this.showLoader='';
      this.submitted = false;
      if (res.status === 'success') {
        this.sendReferralForm.controls['email'].setValue('');
        this.sucessMessage = "Your referral email has been sent successfully."
        setTimeout(()=>{
          this.sucessMessage = '';
          },5000)
      } else{
        this.referral_send_validation = res.message;
        setTimeout(()=>{
          this.referral_send_validation = '';
          },5000)
      }
    }, err => {
      console.log(err);
    });
  }

  checkSpecialReferCode(){
    this.userService.checkSpecialReferCode().subscribe(res => {
      this.showLoader ='';
     if (res.status === 'success') {
        this.specialReferCode = res.entities && res.entities.promo_code ? res.entities.promo_code :'';
      }
    }, err => {
      console.log(err);
    });
  }
 
}